import { render, staticRenderFns } from "./AlunoCurso.vue?vue&type=template&id=46a9e609&"
import script from "./AlunoCurso.vue?vue&type=script&lang=js&"
export * from "./AlunoCurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports